import { Stack, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { SOURCING_EXTERNAL_MAX_CANDIDATES_SHOWN } from '../constants/sourcingExternalMaxCandidatesShown';

const containerSx: SxProps<Theme> = {
  p: '20px',
  gap: '40px',
  flex: 1
};

export const SourcingExternalImproveFilterWarning = () => {
  const { palette } = useTheme();

  return (
    <Stack
      sx={{
        ...containerSx,
        backgroundColor: palette.warningV2.light,
        border: `${palette.border.small.warning.dark}`
      }}
    >
      <Stack sx={{ gap: '15px' }} height="100%" justifyContent="center">
        <Typography
          variant="heading"
          sx={{
            color: 'warningV2.dark'
          }}
        >
          {SOURCING_EXTERNAL_MAX_CANDIDATES_SHOWN} candidates shown.
        </Typography>
        <Typography variant="subtext" color="warningV2.dark">
          Improve the relevance of your search by using the filters on the left.
        </Typography>
      </Stack>
    </Stack>
  );
};
